'use client';

import dynamic from 'next/dynamic';

const LazyComponent = dynamic(
  () => import(/* webpackChunkName: "component-landing-case-evaluation-form" */ './form'),
  {
    ssr: false,
    loading: () => (
      <>
        <h2 className="text-landing-h3 mb-3">Free case evaluation</h2>
        <div className="min-h-[360px] bg-white w-full mb-4" />
        <div className="bg-landing-primary flex items-center gap-2 justify-center w-full rounded-lg text-landing-body-inverse text-base px-4 py-3">
          <span>Start Your Claim</span>
          <span className="w-4 h-4" />
        </div>
        <div className="h-[72px] w-full" />
      </>
    ),
  }
);

export default function FormWrapper(props: { consent: string; title: string }) {
  return <LazyComponent {...props} />;
}
